'use strict';

angular.module('shiftTraderApp')
  .controller('InvoiceModalCtrl', function ($scope, $uibModalInstance, org, ServerUrls, Session) {
  
  var vm = this
  vm.org = org

  vm.state = {
    isLoading: false,
    invoiceOffset: null,
    invoices: null
  }

  vm.loadMoreInvoices = function () {
    if (!vm.state.isLoading) {
      vm.state.isLoading = true

      vm.org.getInvoiceHistory(vm.state.invoiceOffset, 10)
        .then(function (inv) {
          vm.state.isLoading = false

          var charges = (vm.state.invoices || []).concat(inv.data)

          var seenInvoiceIds = []
          var invoiceItems = []
          lodash.each(charges, function (charge) {
            if (!lodash.includes(seenInvoiceIds, charge.invoice) || !charge.invoice) {
              invoiceItems.push(charge)
              seenInvoiceIds.push(charge.invoice)
            }
          })

          vm.state.invoices = invoiceItems

          if (vm.state.invoices.length > 0) {
            console.log(vm.state.invoices)
            vm.state.invoiceOffset = lodash.last(vm.state.invoices).created
          } else {
            vm.state.invoiceOffset = null
          }
        })
    }
  }

  vm.getReceiptDownloadUrl = function(invoice) {
    return ServerUrls.current.railsApi + 'organizations/' + vm.org.id + '/charges/' + invoice.id + '/receipt?access_token=' + Session.getAccessToken();
  }

  vm.close = function () {
    $uibModalInstance.close()
  }

  vm.loadMoreInvoices()

});
